import React from 'react'
import './EditFieldsDialog.scss'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import EditDisclaimeText from '../EditDisclaimeText/EditDisclaimeText'
import EditIcon from '@material-ui/icons/Edit'

const styles = {
  muiDialogActions: {
    padding: '0px'
  },
  dialogPaper: {
    minHeight: '687px',
    maxHeight: '658px',
    maxWidth: '700px',
    width: '700px'
  },
  root: {
    margin: 0,
    padding: '17px 20px'
  },
  editPen: {
    fontSize: '14px',
    position: 'relative',
    top: '1px'
  }
}

const EditFieldsDialog = props => {
  const DEFAULT_DISCLAIMER_TEXT = '*Subject Property - Is a Market/Affordable property.'
  const { isDialogOpen, classes, contentNote, dialogTitle, disclaimerForm, disclaimerText, showDisclaimer, isDisclaimerNeeded, defaultDisclaimerText = DEFAULT_DISCLAIMER_TEXT } = props

  return (
    <div className="edit-property-details" data-testid="edit-property-details">
      <Dialog
        open={isDialogOpen}
        maxWidth={'sm'}
        classes={{ paper: classes.dialogPaper }}
        data-testid="propertyDetails-comps-dialog"
      >
        <DialogTitle disableTypography className={classes.root}>
          <div className="property-details">
            <div className="title">{dialogTitle}</div>
            <IconButton aria-label="close" className={classes.closeButton} onClick={props.handleClose} data-testid="propertyDetails-comps-dialog-close">
              <CloseIcon />
            </IconButton>
          </div>
          <div className="contentNote">
            {contentNote}
          </div>
        </DialogTitle >
        <DialogContent>
          <div className="child-component">
            {props.children}
          </div>
        </DialogContent>
        { isDisclaimerNeeded && (
          <div className="disclaimer_text">
            <span className="add_disclaimer_text">{(disclaimerText && disclaimerText.trim()) ? disclaimerText : '+ Add Disclaimer text'}</span>
            <div
              onClick={props.editDisclaimerText}
              data-testid="add_disclaimer_edit"
              className="add_disclaimer_edit"
            >
              <EditIcon className={classes.editPen} />
            </div>
          </div>
        )}
        <DialogActions className={classes.muiDialogActions}>
          <div className="action-area-propertyDetails">
            {!disclaimerForm && (
              <div className="btn-box">
                <Button className="btn cancel" data-testid="propertyDetails-reset" id="propertyDetails-reset" variant="contained" size="large" onClick={props.handleReset} >
                  <span className="reset">Reset</span>
                </Button>
                <Button className="btn done" data-testid="propertyDetails-done" id="propertyDetails-done" variant="contained" size="large" onClick={props.savePropertyDetails}>
                  <span className="tick"><img src="/images/btn_done.svg" /></span>
                  <span className="done">Done</span>
                </Button>
              </div>
            )}
            {disclaimerForm && (
              <EditDisclaimeText
                disclaimerText={disclaimerText}
                updateDisclaimerText={props.updateDisclaimerText}
                cancelDisclaimerText={props.cancelDisclaimerText}
                showDisclaimer={showDisclaimer}
                handleShowDisclaimer={props.handleShowDisclaimer}
                defaultDisclaimerText={defaultDisclaimerText}
              />
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  )
}

EditFieldsDialog.propTypes = {
  isDialogOpen: PropTypes.bool,
  classes: PropTypes.object,
  children: PropTypes.any,
  handleClose: PropTypes.func,
  handleReset: PropTypes.func,
  savePropertyDetails: PropTypes.func,
  contentNote: PropTypes.string,
  dialogTitle: PropTypes.string,
  disclaimerText: PropTypes.string,
  disclaimerForm: PropTypes.bool,
  updateDisclaimerText: PropTypes.func,
  cancelDisclaimerText: PropTypes.func,
  showDisclaimer: PropTypes.bool,
  handleShowDisclaimer: PropTypes.func,
  editDisclaimerText: PropTypes.func,
  isDisclaimerNeeded: PropTypes.bool,
  defaultDisclaimerText: PropTypes.string
}

export default withStyles(styles)(EditFieldsDialog)
